import styled from 'styled-components'
import { tokens } from '@arvoreeducacao/bonsai-ds'
const { colors, sizes } = tokens

export const Container = styled.div`
  width: 100%;
  height: 100vh;
  background: ${colors.white};
  left: 0;
  top: 0;
  z-index: 10;
  position: fixed;
  align-items: center;
  justify-content: center;
  overflow-y: auto;

  @media (min-width: ${sizes.mdScreen}px) {
    max-width: 470px;
    height: 510px;
    margin: ${tokens.spacing.verticalXxxlarge} 0;
    border-radius: ${tokens.radius.large};
    left: 50%;
    transform: translateX(-50%);
  }
`

export const Wrapper = styled.div`
  width: 100%;
  padding-top: 24px;
  padding-bottom: 16px;
  display: flex !important;
  gap: 16px;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  margin: 0 auto;
  position: relative;

  @media (min-width: ${sizes.mdScreen}px) {
    max-width: 470px;
    align-items: center;
    justify-content: space-between;
  }
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: center;
  justify-content: center;
`

export const CircleImage = styled.img`
  width: 200px;
  height: 200px;
  margin: 0 auto;
`

export const Title = styled.h1`
  text-align: center;
  font-size: ${sizes.h[5].tablet};
  line-height: 30px;
  color: ${colors.primary};
  margin-top: 32px;
  margin-bottom: 8px;
  font-weight: bold;

  @media (min-width: ${sizes.mdScreen}px) {
    font-size: ${sizes.h[4].tablet};
    line-height: 30px;
  }
`

export const Description = styled.p`
  font-size: ${sizes.text}px;
  line-height: 28px;
  color: ${colors.black5};
  text-align: center;
  max-width: 400px;
  margin: 0 auto;
`

export const ButtonContainer = styled.div`
  width: 100%;
  display: flex;
  padding: 16px;
  position: sticky;
  bottom: 0;
  background: ${colors.white};

  @media (min-width: ${sizes.mdScreen}px) {
    padding: 0px;
    padding-top: 16px;
  }
`
